import { BreadcrumbService } from '@policoders/ds';
import { useService } from '@policoders/di';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AdministrationPage = () => {
  const breadcrumb = useService<BreadcrumbService>('BreadcrumbService');
  useEffect(() => {
    breadcrumb.set([{ label: 'Administration', value: '/administration' }]);
  }, [breadcrumb]);

  const navigate = useNavigate();
  const handleCompanies = () => {
    navigate('companies');
  };
  const handleUsers = () => {
    navigate('users');
  };

  return (
    <>
      <div className="row gy-3">
        <div className="col-lg-6">
          <div className="bg-secondary text-light p-5 rounded" role="button" onClick={handleUsers}>
            <h1 className="display-5">Usuários</h1>
            <hr />
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="bg-secondary text-light p-5 rounded"
            role="button"
            onClick={handleCompanies}>
            <h1 className="display-5">Empresas</h1>
            <hr />
          </div>
        </div>
      </div>
    </>
  );
};
